import React from 'react';
import { useNavigate } from 'react-router-dom';

const CallToAction = ({ data }) => {
  const navigate = useNavigate();

  // Default config if no data provided
  const config = data || {
    title: "Ready to Join Choice MCN?",
    subtitle: "No setup fee • 24-hour approval • Monthly payouts",
    buttons: []
  };

  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-3xl p-10 lg:p-14 text-white text-center shadow-xl">
          {/* Title */}
          <h2 className="text-3xl font-extrabold">{config.title}</h2>
          
          {/* Subtitle */}
          <p className="mt-2 text-white/90">{config.subtitle}</p>

          {/* CTA Buttons */}
          <div className="mt-6 flex flex-wrap gap-3 justify-center">
            {config.buttons.map((button, index) => (
              <button
                key={index}
                onClick={() => navigate(button.link)}
                className={
                  button.style === 'primary'
                    ? "px-6 py-3 rounded-xl font-semibold bg-white text-slate-900 hover:bg-white/90 transition-all"
                    : "px-6 py-3 rounded-xl font-semibold bg-white/10 border border-white/20 hover:bg-white/20 transition-all"
                }
              >
                {button.text}
              </button>
            ))}
          </div>

          {/* Additional Features/Benefits */}
          {config.features && config.features.length > 0 && (
            <div className="mt-8 flex flex-wrap gap-6 justify-center text-sm text-white/80">
              {config.features.map((feature, index) => (
                <div key={index} className="flex items-center gap-2">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path>
                  </svg>
                  <span>{feature}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default CallToAction;